import React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { buttonStyle } from "./colors";
import { Grid, IconButton } from "@mui/material";
import { IoMdReverseCamera } from "react-icons/io";

import Top7 from "./outfits/top 7.png";
import Bottom2 from "./outfits/bottom 2.png";

const NEW_OUTFITS = [
  { id: 0, imageId: Top7, type: "top", new: true },
  { id: 1, imageId: Bottom2, type: "bottom", new: true },
];
var NEWOUTFITS_LOG = [NEW_OUTFITS[0]];
//var CLOTHESINDEX_LOG = 1;
function ManualAddResults() {
  const navigate = useNavigate();

  const [newManualClothes, setNewManualClothes] =
    React.useState(NEWOUTFITS_LOG);
  //const [clothesIndex, setClothesIndex] = React.useState(CLOTHESINDEX_LOG);
  const handleDiscard = (value) => {
    const discard = (oldValues) => {
      return oldValues.filter((outfit) => outfit !== value);
    };
    NEWOUTFITS_LOG = discard(NEWOUTFITS_LOG);
    setNewManualClothes(NEWOUTFITS_LOG);
  };
  const handleAdd = () => {
    NEWOUTFITS_LOG = [...NEWOUTFITS_LOG, NEW_OUTFITS[1]];
    setNewManualClothes(NEWOUTFITS_LOG);
  };

  return (
    <NavBarLayout
      title={"Add Manually"}
      onBackButtonClicked={() => navigate("/addmethods")}
      active={1}
    >
      <div className="AutoAddResults-container">
        <span className="AddMethod-instructionsText">
          Here are the clothes you want to add:
        </span>
        <div className="AutoAddResults-clothes-container">
          <div>
            <span className="MyCloset-caption">Tops </span>
            <Grid container spacing={1} rowGap={1}>
              {newManualClothes
                .filter((outfit) => outfit.type === "top")
                .map((outfit) => (
                  <Grid item xs={4} key={outfit.id}>
                    <div className="MyCloset-outfitContainer">
                      <img
                        style={{ height: "15vh", width: "120%" }}
                        src={outfit.imageId}
                      ></img>
                    </div>
                    <div className="ManualAddResults-button-group">
                      <Button
                        onClick={() => handleDiscard(outfit)}
                        sx={{
                          padding: 1,
                          paddingY: 0.5,
                          fontSize: 12,
                          ...buttonStyle,
                        }}
                        variant="contained"
                      >
                        Discard
                      </Button>
                      <IconButton onClick={() => navigate("/camerascreen")}>
                        <IoMdReverseCamera color="#E17667" size="2rem" />
                      </IconButton>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </div>
          <div>
            <span className="MyCloset-caption">Bottoms </span>
            <Grid container spacing={2} rowSpacing={0.01}>
              {newManualClothes
                .filter((outfit) => outfit.type === "bottom")
                .map((outfit) => (
                  <Grid item xs={4} key={outfit.id}>
                    <div className="MyCloset-outfitContainer">
                      <img
                        style={{ height: "15vh", width: "120%" }}
                        src={outfit.imageId}
                      ></img>
                    </div>
                    <div className="ManualAddResults-button-group">
                      <Button
                        onClick={() => handleDiscard(outfit)}
                        sx={{
                          padding: 1,
                          paddingY: 0.5,
                          fontSize: 12,
                          ...buttonStyle,
                        }}
                        variant="contained"
                      >
                        Discard
                      </Button>
                      <IconButton onClick={() => navigate("/camerascreen")}>
                        <IoMdReverseCamera color="#E17667" size="2rem" />
                      </IconButton>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </div>
        </div>
      </div>
      <div className="ManualAddResults-button-group">
        <Button
          onClick={() => {
            handleAdd();
            navigate("/camerascreen");
          }}
          sx={{
            fontSize: 16,
            paddingX: 0,
            margin: "1rem",
            bottom: "10px",
            position: "absolute",
            transform: "translate(-60%, 0)",

            width: "40%",

            ...buttonStyle,
          }}
          variant="contained"
        >
          Add More Items
        </Button>
        <Button
          onClick={() => {
            NEWOUTFITS_LOG = [NEW_OUTFITS[0]];
            setNewManualClothes(NEW_OUTFITS[0]);
            navigate("/mycloset", { state: { newClothes: newManualClothes } });
          }}
          sx={{
            fontSize: 16,
            paddingX: 0,

            margin: "1rem",
            bottom: "10px",
            position: "absolute",

            width: "40%",
            transform: "translate(60%, 0)",
            ...buttonStyle,
          }}
          variant="contained"
        >
          Add to My Closet
        </Button>
      </div>
    </NavBarLayout>
  );
}

export default ManualAddResults;
